var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTvaroh = function SvgTvaroh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tvaroh_svg__a)",
    d: "M183.883 102.12C166.775 95 150.743 63 132.049 63c-12.506 0-9.318 6.865-12.989 11.055C97.596 98.562 77.777 90.97 64.189 112c-9.645 14.929 42.271 15 51.329 15 8.051 0 57.852-5.953 62.611-3.354s22.662-14.49 5.754-21.526"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tvaroh_svg__b)",
    d: "M236.991 119.467c-12.147-7.616-32.945-7.4-37.984-10.361-2.724-1.6-18.274-13.053-33.007-10.106-15 3-22-11-29-11-11 0-27.587 8.206-47 14.948C80.661 106.191 59 111 59 116c0 7 45 36 73 36s107-16.758 107-28.589a4.49 4.49 0 0 0-2.009-3.944"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tvaroh_svg__c)",
    d: "M33 119c8.112-6.039 25.827-9.174 35-11.2 2.5-.551 11-2.8 17-2.8a88.2 88.2 0 0 1 22 3c6.031 1.969 21.046 11.517 33 6 13-6 40.78-.746 58.872 5.161s25.128 12.8 25.128 12.8S182 149 119 149c-54 0-89.005-15-89-25 0-2 1.225-3.679 3-5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tvaroh_svg__d)",
    d: "M135 140.646c53.559 0 114.127-12.158 101.928-21.646 11.139 7.922-3.1 15.321-12.55 30.913C209.1 175.083 182.489 207 135 207s-74.1-31.917-89.378-57.087c-9.45-15.592-23.689-22.991-12.55-30.913-12.199 9.488 48.369 21.646 101.928 21.646"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tvaroh_svg__a",
    x1: 67.352,
    x2: 176.982,
    y1: 99.608,
    y2: 68.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.097,
    stopColor: "#268EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#449EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#75B8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#B9DAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tvaroh_svg__b",
    x1: 69.08,
    x2: 190.596,
    y1: 122.304,
    y2: 88.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.097,
    stopColor: "#268EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#449EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#75B8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#B9DAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tvaroh_svg__c",
    x1: 39.312,
    x2: 219.15,
    y1: 127,
    y2: 127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#268EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#449EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#75B8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799,
    stopColor: "#B9DAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tvaroh_svg__d",
    x1: 29,
    x2: 241,
    y1: 163,
    y2: 163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })))));
};
export default SvgTvaroh;